/**
 * Query params for login/register links — avoids carrying stale redirect_from
 * (e.g. after logout → home → Login).
 */
export function buildAuthRouteQuery(route) {
  const query = {};
  if (route.query.src) {
    query.src = route.query.src;
  }
  if (route.path.startsWith('/jobseeker')) {
    return query;
  }
  if (route.path.startsWith('/myprofile')) {
    query.redirect_from = route.fullPath;
    return query;
  }
  const { redirect_from: redirectFrom } = route.query;
  if (redirectFrom && route.path !== '/') {
    query.redirect_from = redirectFrom;
  }
  return query;
}
